'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAccessAlarm = function MdAccessAlarm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.4q4.8 0 8.2-3.5t3.4-8.3-3.4-8.2-8.2-3.4-8.2 3.4-3.4 8.2 3.4 8.3 8.2 3.5z m0-26.8q6.3 0 10.6 4.5t4.4 10.5-4.4 10.6-10.6 4.4-10.6-4.4-4.4-10.6 4.4-10.5 10.6-4.5z m0.9 6.8v8.7l6.6 3.9-1.2 2.1-7.9-4.7v-10h2.5z m-7.8-7.8l-7.6 6.4-2.1-2.5 7.6-6.4z m23.5 3.9l-2.1 2.6-7.6-6.5 2.1-2.5z' })
        )
    );
};

exports.default = MdAccessAlarm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/access-alarm.js
// module id = 3017
// module chunks = 168707334958949